import { PhoneInput } from 'components/ui/PhoneInput/PhoneInput';
import type { Field } from 'models';
import { type ConnectedProps, connect } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getCountriesForSelect } from 'selectors';

type PropsFromRedux = ConnectedProps<typeof connector>;
type PhoneInputFieldProps = PropsFromRedux & {
  field: Field;
  handleBlur: () => void;
  handleChange: () => void;
};

const PhoneInputFieldComponent = ({
  countries,
  field,
  handleBlur,
  handleChange,
}: PhoneInputFieldProps) => {
  const {
    defaultValue,
    error,
    help,
    hidden,
    id,
    label,
    name,
    readOnly,
    required,
    type,
  } = field;

  return (
    <PhoneInput
      value={defaultValue}
      error={error}
      help={help}
      hidden={hidden}
      id={id}
      label={label}
      name={name}
      readOnly={readOnly}
      required={required}
      type={type}
      countries={countries}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  countries: getCountriesForSelect(state),
});

const connector = connect(mapStateToProps);

export const PhoneInputField = connector(PhoneInputFieldComponent);
